var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-circle",
    transform: "translate(-1.15 -1.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734",
    transform: "translate(1.15 1.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    d: "M8.15-.85a9,9,0,0,1,9,9,9,9,0,0,1-9,9,9,9,0,0,1-9-9,9,9,0,0,1,9-9Zm0,16.652A7.652,7.652,0,1,0,.5,8.15,7.661,7.661,0,0,0,8.15,15.8Z",
    transform: "translate(0.85 0.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M8.824,14.493a.674.674,0,0,1-.477-1.151l5-5A.674.674,0,1,1,14.3,9.3l-5,5A.672.672,0,0,1,8.824,14.493Z",
    transform: "translate(-2.322 -2.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M13.819,14.493a.672.672,0,0,1-.477-.2l-5-5A.674.674,0,0,1,9.3,8.347l5,5a.674.674,0,0,1-.477,1.151Z",
    transform: "translate(-2.322 -2.321)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircleWhite);
export default __webpack_public_path__ + "static/media/x-circle-white.c222aeb4971df78ac675459dfacb288d.svg";
export { ForwardRef as ReactComponent };